import { Component } from 'react';
import moment from "moment";

class Clock extends Component {
    constructor(props) {
        super(props);

        var now = new Date();
        var formatter1 = 'YYYY-MM-DD HH:mm:ss';
        var formatter2 = 'HH:mm:ss';

        if (this.props.type === 'datetime') {
            this.state = {
                dateTime: moment(now).format(formatter1)
            };
        }
        else if (this.props.type === 'time') {
            this.state = {
                dateTime: moment(now).format(formatter2)
            };
        }
    }

    componentDidMount() {
        this.timerID = setInterval(
            () => this.tick(), 1000
        );
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        const now = moment(new Date());
        //const end = moment(this.props.loginDateTime);
        //const duration = moment.duration(now.diff(end));

        const formatter1 = 'YYYY-MM-DD HH:mm:ss';
        const formatter2 = 'HH:mm:ss';

        if (this.props.type === 'datetime') {
            this.setState({
                dateTime: now.format(formatter1)
            })
        }
        else if (this.props.type === 'time') {
            this.setState({
                dateTime: now.format(formatter2)
            })
        }
    }

    render() {
        return (
            this.state.dateTime
        );
    }
}

export default Clock;


// WEBPACK FOOTER //
// ./src/components/Common/Clock.js